import request from '../utils/request';
//证书编号查询
export function doCertVerify(data) {
  return request({
    url: 'wap/cert/doCertVerify.html',
    method: 'post',
    data
  })
}
//学时查询
export function doCreditVerify(data) {
  return request({
    url: '/wap/cert/doCreditVerify.html',
    method: 'post',
    data
  })
}
//学时详情
export function toCreditZM(data) {
  return request({
    url: '/wap/learning/toCreditZM.html',
    method: 'post',
    data
  })
}





